// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centrar-pantalla{
    margin: 0 auto;
    width: auto;
    margin-top: -5%;
}

.ajuste{
    margin: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/terms/terms.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".centrar-pantalla{\r\n    margin: 0 auto;\r\n    width: auto;\r\n    margin-top: -5%;\r\n}\r\n\r\n.ajuste{\r\n    margin: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
